<style lang="scss" src='./SensorData.scss' scoped></style>
<template src="./SensorData.html"></template>

<script>
import {
  getSensorData,
} from '@/api/index';

import moment from 'moment';
import i18n from './../../../../i18n';

export default {
  name: 'SensorData',
  props: {
    sensor: {
      required: false,
    },
  },
  data() {
    return ({
      sensorData: [],
      pdfName: null,
      pagination: {
        sensorData: {
          page: 0,
          limit: 100,
          next: null
        }
      },
      loading: {
          sensorData: false,
        },
    });
  },
  computed: {
    sensorDataFiltered: {
      get() {
          let sensorDataAux = this.sensorData;
          if (this.sensorData) {

            const rowsPerPage = this.pagination.sensorData.limit;
            if (this.sensorData.length > rowsPerPage) {
              const currentPage = this.pagination.sensorData.page;
              const start = (currentPage * rowsPerPage) - rowsPerPage;
              const end = start + rowsPerPage;
              sensorDataAux = this.sensorData.slice(start, end)
            }
          }
          
          // Set Flag newDay to items in order to know if the next element belongs to same date that the back element
          if (sensorDataAux && sensorDataAux.length > 0) {
            let lastReadingTime = null;
            sensorDataAux = sensorDataAux.map((sensorData) => {
              const readingTimeObj = new Date(sensorData.reading_time);
              let newDay = true;
              if (lastReadingTime) {
                newDay = !(readingTimeObj.getFullYear() === lastReadingTime.getFullYear() &&
                        readingTimeObj.getMonth() === lastReadingTime.getMonth() &&
                        readingTimeObj.getDate() === lastReadingTime.getDate());
                lastReadingTime = newDay ? readingTimeObj : lastReadingTime;
              } else {
                lastReadingTime = readingTimeObj
              }
              return {...sensorData, newDay: newDay};
            });
          }
          return sensorDataAux;
      },
    },

    startRecords: function(){
      const paginationSD = this.pagination.sensorData;
      return (paginationSD.page * paginationSD.limit) - paginationSD.limit + 1;
    },

    endRecords: function(){
      const paginationSD = this.pagination.sensorData;
      const end = paginationSD.page * paginationSD.limit;
      return end > this.sensorData.length ? this.sensorData.length : end;
    },

    canGetSensorDataFromStore: function(){
      const paginationSD = this.pagination.sensorData;
      const start = (((paginationSD.page + 1) * paginationSD.limit) - paginationSD.limit) + 1;
      return start <= this.sensorData.length;
    },

  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && oldSensor && newSensor.sensor_id !== oldSensor.sensor_id) {
        this.loadData();
      }
    }
  },

  methods: {
    downloadCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      let arrData = this.getCsvAllData();
      if(arrData.length > 0){
          csvContent += [
              Object.keys(arrData[0]).join(","),
              ...arrData.map(item => Object.values(item).join(","))
          ]
              .join("\n")
              .replace(/(^\[)|(\]$)/gm, "");

          const data = encodeURI(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", this.pdfName + ".csv");
          link.click();
      }
    },
    getCsvAllData(){
      let readings = this.sensorDataFiltered;
      if(readings.length>0){
        let data = [];
        readings.forEach((sensorData)=>{
          let obj = {}
          let last_reading = this.G_formatDate({date: sensorData.reading_time, pretty: false});
          obj[i18n.t('general.date')] = last_reading ? last_reading.replace(/,/g, "") : last_reading;
          let temperature = this.G_getMeasurement({ val: sensorData.temperature,
                      uom: this.consts.UOM.TEMP,
                      addUnit: true, invertUOM: false });
          obj[i18n.t('alerts.Temperature')] = temperature.replace('°', '');
          obj[i18n.t('alerts.Salinity')] = this.G_getMeasurement({ val: sensorData.bulk_ec,
                      uom: this.consts.UOM.SALINITY,
                      addUnit: true, invertUOM: false });
          obj[i18n.t('alerts.Dielectric')] = this.G_getMeasurement({ val: sensorData.dielectric,
                      uom: this.consts.UOM.DIELECTRIC,
                      addUnit: true, invertUOM: false });
          obj[i18n.t('alerts.Moisture')] = this.G_getMeasurement({ val: sensorData.vwc,
                      uom: this.consts.UOM.MOISTURE,
                      addUnit: true, invertUOM: false });

          data.push(obj);
        })
        let headers = [];
        //let filters = this.getHeadersObj();
        //headers.push(filters);
        return [...headers, ...data];
      }
      return [];
    },
    
    scrollToTopSensorDataTbl() {
      const dateHeaderElement = document.querySelector('.date-header:first-child');
      if (dateHeaderElement) {
        dateHeaderElement.scrollIntoView();
      }
    },

    changeSensorDataPage(newPage) {
      this.pagination = {...this.pagination, sensorData: {
        ...this.pagination.sensorData,
        page: newPage
      }};
      this.scrollToTopSensorDataTbl();
    },

    backSensorDataPage() {
      this.changeSensorDataPage(this.pagination.sensorData.page - 1);
    },

    nextSensorDataPage() {
      if (this.canGetSensorDataFromStore) {
        this.changeSensorDataPage(this.pagination.sensorData.page + 1);
      } else {
        this.loadSensorData();
      }
    },

    resetSensorDataPagination() {
      this.pagination = {...this.pagination, sensorData: {
        ...this.pagination.sensorData,
        next: null,
        page: 0
      }};
    },

    async loadSensorData() {
      this.loading.sensorData = true;

      let pagination = this.pagination.sensorData;
      await getSensorData(this.sensor.sensor_id, {
        limit: pagination.limit,
        next: pagination.next
      }).then((response) => {
        this.pagination.sensorData = {
          ... this.pagination.sensorData,
          next: response.next_page,
          page: ((response.rows && response.rows.length) ?
            this.pagination.sensorData.page + 1 : this.pagination.sensorData.page)
        };

        if (this.pagination.sensorData.page > 1) {
          this.sensorData = [...this.sensorData, ...response.rows];
        } else {
          this.sensorData = response.rows;
        }

        this.loading.sensorData = false;
      });
    },

    loadData() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Sensors Data");
        this.$analytics.logEvent("web_sensors_data");
      }

      this.sensorData = [];
      this.resetSensorDataPagination();
      if (this.sensor){
        this.loadSensorData();
      }
    },
  },

  beforeCreate() {},

  created() {
    let date = new Date();
    date = moment(date).format("MM-DD-YYYY");
    this.pdfName = this.sensor.serial_number + '_' + i18n.t('sensors.data') + '_' + date;
  },

  mounted() {
    this.loadData();
  },
};
</script>
